import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { Typography, Stack, Box, Paper, Button } from '@mui/material';
// components
import Iconify from '../../../../components/Iconify';

// ----------------------------------------------------------------------

const RootStyle = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: 24,
  border: '1px solid #F1F5F9',
  boxShadow: 'none',
  background: '#FFF',
  textAlign: 'center',
}));

// ----------------------------------------------------------------------

YangaReferralCard.propTypes = {
  onInvite: PropTypes.func,
};

export default function YangaReferralCard({ onInvite }) {
  return (
    <RootStyle>
      <Box sx={{ 
          width: 56, 
          height: 56, 
          borderRadius: '50%', 
          bgcolor: 'primary.lighter', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          color: 'primary.main',
          mx: 'auto',
          mb: 2
      }}>
        <Iconify icon="eva:people-outline" width={28} height={28} />
      </Box>
      
      <Typography variant="subtitle1" sx={{ fontWeight: 800, mb: 1 }}>Invite & Earn</Typography>
      <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3, px: 2 }}>
        Share your referral link with friends and get rewarded for every transaction they make.
      </Typography>
      
      <Button 
        fullWidth 
        variant="contained" 
        onClick={onInvite}
        sx={{ 
            bgcolor: 'primary.lighter', 
            color: 'primary.main', 
            boxShadow: 'none',
            borderRadius: '12px',
            fontWeight: 700,
            '&:hover': { bgcolor: 'primary.light', color: 'common.white' }
        }}
      >
        Copy Link
      </Button>
    </RootStyle>
  );
}
